import { render, staticRenderFns } from "./WeetControlPlayer.vue?vue&type=template&id=5a8010e1&scoped=true"
import script from "./WeetControlPlayer.vue?vue&type=script&lang=ts"
export * from "./WeetControlPlayer.vue?vue&type=script&lang=ts"
import style0 from "./WeetControlPlayer.vue?vue&type=style&index=0&id=5a8010e1&prod&scoped=true&lang=scss"
import style1 from "./WeetControlPlayer.vue?vue&type=style&index=1&id=5a8010e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8010e1",
  null
  
)

export default component.exports